import { Dialog, DialogContent, DialogActions, Typography, Box } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import { CustomButton } from '../';

const SaveConfirmationDialog = ({
  open,
  onClose,
  onConfirm,
  title = 'Confirmar cambios',
  message,
  entityName = 'información',
  confirmText = 'Guardar',
  cancelText = 'Cancelar',
  confirmVariant = 'warning',
  isLoading = false,
}) => {
  const defaultMessage = `¿Está seguro que desea guardar los cambios realizados en ${entityName}?`;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          borderRadius: '10px',
          boxShadow: '0 10px 40px rgba(0,0,0,0.15)',
        },
      }}
    >
      <DialogContent sx={{ textAlign: 'center', py: 4 }}>
        <Box sx={{ mb: 2 }}>
          <SaveIcon
            sx={{
              fontSize: 60,
              color: 'primary.main',
              mb: 2,
            }}
          />
        </Box>

        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
          {title}
        </Typography>

        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          {message || defaultMessage}
        </Typography>
      </DialogContent>

      <DialogActions>
        <CustomButton onClick={onClose} variant="danger" disabled={isLoading}>
          {cancelText}
        </CustomButton>

        <CustomButton onClick={onConfirm} variant={confirmVariant} isLoading={isLoading}>
          {confirmText}
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default SaveConfirmationDialog;
